export const GENERAL_ES = {
    "general": {
        "contact": "Contacto",
        "confirm-text": "¿Estás seguro?",
    },
    "dashboard": {
        "is-public": "Público",
    },
    "contact": {
        "subject": "Asunto",
        "message": "Mensaje",
        "send": "Enviar"
    },
    "menu": {
        "properties": "Inmuebles",
        "dashboard": "Inversiones",
        "profile": "Perfil",
        "contact": "Contacto",
        "logout": "Cerrar Sesión"
    },
    "loading": "Cargando...",
    "login": {
        "not-have-account": "¿No tienes una cuenta?",
        "register": "¡Regístrate hoy!",
        "email": "Correo Electrónico",
        "password": "Contraseña",
        "remember": "Recuérdame",
        "acceptTerms": "Acepto los términos y condiciones",
        "login": "Iniciar Sesión",
        "success": "¡Bienvenido de nuevo!",
        "errors": {
            "INVALID_PASSWORD": "La contraseña no es correcta",
            "USER_NOT_FOUND": "No se ha encontrado una cuenta con el email indicado",
            "PENDING_CONFIRMATION": "Aún no has confirmado tu cuenta. Por favor, revisa tu correo electrónico",
            "DEFAULT": "No se ha podido iniciar sesión. Inténtelo de nuevo más tarde!"
        }
    },
    "register": {
        "have-account": "¿Ya tienes una cuenta?",
        "login": "Iniciar Sesión",
        "name": "Nombre",
        "country": "País",
        "email": "Correo Electrónico",
        "password": "Contraseña",
        "repeat-password": "Repetir Contraseña",
        "register-button": "Registrarse",
        "confirmation-code-success": "Cuenta confirmada con éxito. Redirigiendo...",
        "confirmation-code-error": "Error al confirmar la cuenta. Por favor, inténtalo de nuevo más tarde",
        "confirmation-code-invalid": "El código introducido no es correcto. Si el problema persiste, contacta al administrador",
        "email-already-in-use": "El correo electrónico ya está en uso",
        "register-success": "Cuenta creada con éxito. Se ha enviado un correo de confirmación para activar la cuenta. Revisa tu bandeja de entrada o tu carpeta de spam",
        "passwords-not-match": "Las contraseñas no coinciden",
        "register-generic-error": "Error al crear la cuenta. Por favor, inténtalo de nuevo más tarde"
    },
    "profile": {
        "edit-profile": "Editar Perfil",
        "form-field-name": "Nombre",
        "form-field-language": "Idioma",
        "edit-profile-success": "Perfil actualizado correctamente!. Recargando...",
        "edit-profile-error": "Error al actualizar el perfil. Inténtalo de nuevo más tarde",
        "edit-profile-button-update": "Actualizar perfil",
        "choose-avatar-button": "Seleccionar imagen"
    },
    "public-contact": {
        "title": "Contacto",
        "text": "¿Tienes alguna pregunta? Envíanos un mail a contact [@] reentalai.pro",
    },
    "public-menu": {
        "dashboard": "Tablero",
        "register": "Registro",
        "login": "I. Sesión",
    },
    "landing": {
        "subtitle": "Genera ingresos pasivos invirtiendo en inmuebles",
        "subtitle2": "Te ayudamos a construir riqueza invirtiendo como pocos, en un sector conocido por todos",
        "register-button": "Registrarme gratis",
        "about": "Accede a toda la información"

    },
    "building": {
        "title": "Inmuebles",
        "subtitle": "Nuestros profesionales encuentran el inmueble idóneo para ofrecerte las mejores condiciones de rentabilidad/riesgo*",
        "subtitle2": "* Operaciones supervisadas bajo criterio de la SEC y CNMV.",

    },
    "about": {
        "buildings": "Nuestros inmuebles"
    },
    "primeng": {
        "startsWith": "Empieza por",
        "contains": "Contiene",
        "notContains": "No contiene",
        "endsWith": "Termina por",
        "equals": "Igual",
        "notEquals": "No igual",
        "noFilter": "Sin filtro"
    }
}
